import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, LinkData } from '../../types'
import { CmsConverterService, defaultLinkData } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class DownloadLinkWithIconConverter extends CmsConverterService<DownloadLinkWithIconData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      component: 'DownloadLinkWithIconComponent',
      type: formData.st_type?.value?.identifier ?? '',
      email: formData.st_url?.value?.formData?.url?.value ?? '',
      link: formData.st_url ?? defaultLinkData
    }
  }
}

export const DOWNLOAD_LINK_WITH_ICON_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, DownloadLinkWithIconData>>('DownloadLinkWithIconConverter')

export interface DownloadLinkWithIconData extends ConvertedComponentData {
  component: string;
  type: string;
  email: string;
  link: LinkData;
}
